export function formatTime(seconds: number) : string {

    const date = new Date(seconds * 1000);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const sec = date.getSeconds().toString().padStart(2, '0');

    const basetime = minutes.toString() + ':' + sec; 
    
    return hours > 0 ? hours.toString() + ':' + basetime : basetime;
}